module.exports = __webpack_public_path__ + "static/harvest-58e6a6b00ea43bba45aef29051265165.jpg";